import SessionManager from "../auth/sessionmanager";
import { BASE_URL } from "./settings";
import { api_forfreight_url } from "../data/urlData";

export async function postDataForLogin(type, userData) {
    const payload = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(userData)
    };

    try {
        const response = await fetch(BASE_URL + type, payload);

        // Check if the response is successful
        if (!response.ok) {
            const errorText = await response.text(); // Read response as text for error logging
            console.error(`HTTP error! Status: ${response.status}, Message: ${errorText}`);
            throw new Error(`Request failed with status ${response.status}: ${errorText}`);
        }

        // Check if the response's content type is JSON
        const contentType = response.headers.get('Content-Type');
        let result;
        if (contentType && contentType.includes('application/json')) {
            result = await response.json();  // Parse as JSON if the response is JSON
        } else {
            const responseText = await response.text();  // Read as plain text
            result = { token: responseText };  // If it's a token, handle it separately
        }

        return result;

    } catch (error) {
        // Log any error that occurs during fetch or response parsing
        console.error('Error during postDataForLogin:', error);
        return { error: 'An error occurred. Please try again.' }; // Return a structured error response
    }
}



export async function postData(endPoint, inputObj) {
    let token = SessionManager.getToken();
    let payload = {
        method: 'POST',
        headers: {           
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        body: JSON.stringify(inputObj)

    }
    return fetch(BASE_URL + endPoint, payload)
        .then(function (response) {
            return response.json();
        }).then(function (result) {
            return result;
        }).catch(function (error) {
            return error;
        });
}


export async function getData(endPoint, inputObj) {
    let token = SessionManager.getToken();

    let payload = {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        body: JSON.stringify(inputObj)
    }
    return fetch(BASE_URL + endPoint, payload)
        .then(function (response) {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(function (result) {
            return result;
        }).catch(function (error) {
            console.log(error);
        });
}

export async function  fetchMarketplaceList() {
    let token = SessionManager.getToken();
    let payload = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },       
    }
    return fetch(`${api_forfreight_url}/marketplace/solvers`, payload)
        .then(function (response) {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            const apiList =  response.json();
            return apiList;
        }).then(function (result) {
            return result;
        }).catch(function (error) {
            console.log(error);
        });
}


export async function  fetchSolvingProcessesMarketplace() {
    let token = SessionManager.getToken();
    let payload = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },        
    }
    return fetch(`${api_forfreight_url}/marketplace/solvingProcesses`, payload)
        .then(function (response) {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            const apiList =  response.json();
            return apiList;
        }).then(function (result) {
            return result;
        }).catch(function (error) {
            console.log(error);
        });
}


export async function CreateNewEndPoint(inputObj) {
    let token = SessionManager.getToken();
    let payload = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        body: JSON.stringify(inputObj)       
    }
    const response = await fetch(`${api_forfreight_url}/onboarder/onboard_solver`, payload);
    if (!response.ok) {
        const errorData = await response.json().catch(() => ({})); // Try to get error details
        throw new Error(errorData.message || response.statusText);
    }
    return response.json();
}



export async function  GetSoverOnboarding() {
    let token = SessionManager.getToken();
    let payload = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        }            
    }
    return fetch(`${api_forfreight_url}/onboarder/onboarded_solvers`, payload)
        .then(function (response) {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            const apiList =  response.json();
            return apiList;
        }).then(function (result) {
            return result;
        }).catch(function (error) {
            console.log(error);
        });
}

export async function  DeleteSoverOnboarding(onboardingId) {
    let token = SessionManager.getToken();
    let payload = {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        }            
    }
    return fetch(`${api_forfreight_url}/onboarder/onboarded_solvers/${onboardingId}`, payload)
        .then(function (response) {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            const apiList =  response.json();
            return apiList;
        }).then(function (result) {
            return result;
        }).catch(function (error) {
            console.log(error);
        });
}


export async function  GetSolvingOnboarding() {
    let token = SessionManager.getToken();
    let payload = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        }            
    }
    const response = await fetch(`${api_forfreight_url}/onboarder/onboarded_solving_processes`, payload)
    if (!response.ok) {
        const errorData = await response.json().catch(() => ({})); // Try to get error details
        throw new Error(errorData.message || response.statusText);
    }
    return response.json();
}


export async function DeleteSolvingOnboarding(onboardingId) {
    const token = SessionManager.getToken();
    const payload = {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }            
    };
    
    try {
        const response = await fetch(
            `${api_forfreight_url}/onboarder/onboarded_solving_processes/${onboardingId}`, 
            payload
        );
        
        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
        }
        
        // For DELETE requests, the response might be empty, so we shouldn't always expect JSON
        return response.status === 204 ? {} : await response.json();
    } catch (error) {
        console.error('Error in DeleteSolvingOnboarding:', error);
        throw error; // Re-throw to let the caller handle it
    }
}

export async function CreateNewSolvingProcesses(inputObj) {
    let token = SessionManager.getToken();
    let payload = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        body: JSON.stringify(inputObj)       
    }
    const response = await fetch(`${api_forfreight_url}/onboarder/onboard_solving_process`, payload);
    if (!response.ok) {
        const errorData = await response.json().catch(() => ({})); // Try to get error details
        throw new Error(errorData.message || response.statusText);
    }
    return response.json();
}